import { component, componentNoSentry } from './bookingsWidget.exports';

// file has to be js
export default {
  component,
  componentNoSentry,
};
